<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <div class="row">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-filter" aria-hidden="true"></i> {{'General.filters' | translate}}</span>
          </p-header>
          <div class="row">
            <div class="col-12 col-md-10">
              <formElement [model]="filters" name="from" [fieldConfig]="getFieldConfig(this.FROM_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="to" [fieldConfig]="getFieldConfig(this.TO_PARAM)" #ref>
              </formElement>
              <formElement [model]="filters" name="user" [fieldConfig]="getFieldConfig(this.USER_PARAM)" #ref>
              </formElement>
            </div>
            <div class="col-12 col-md-2 mt-4">
              <button class="btn btn-primary float-right" (click)="loadExportProcesses()"><i class="fa fa-search"
                  aria-hidden="true"></i> {{'General.search.text' | translate}}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <!-- <div *ngIf="(exportProcesses && exportProcesses.length>0); else noExportProcess"> -->
    <div class="row mt-5 mb-2">
      <div class="col-12">
        <span class="c label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing' |
          translate }} {{exportProcesses ? exportProcesses.length : '0'}} exportaciones </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- sortField="{{this.mySortField}}" sortOrder="{{this.mySortOrder}}"  -->
        <p-table #dt [value]="exportProcesses" [resizableColumns]="true" [responsive]="true" [paginator]="false"
          dropdownAppendTo="body">
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'identifier'" class="IDTH">
                <p-sortIcon [field]="'identifier'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'name'" class="TEXTTH"> {{'General.name'|translate}} <p-sortIcon [field]="'name'">
                </p-sortIcon>
              </th>
              <th [pSortableColumn]="'creationDate'" class="DATETH"> {{'General.date.text'|translate}} <p-sortIcon
                  [field]="'creationDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'description'" class="text-left p-t-md p-b-md LONGTEXTTH">
                {{'General.description'|translate}} <p-sortIcon [field]="'description'">
                </p-sortIcon>
              </th>
              <th [pSortableColumn]="'exportProcess.execution.status'" class="text-md-center USERTH">
                {{'General.state'|translate}} <p-sortIcon [field]="'exportProcess.execution.status'">
                </p-sortIcon>
              </th>
              <th [pSortableColumn]="'ownerUser.identifier'" class="USERTH"> Usuario <p-sortIcon
                  [field]="'ownerUser.identifier'">
                </p-sortIcon>
              </th>
              <th class="action-column-4buttons">{{'General.actions'|translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-exportProcess>
            <tr>
              <td field="name" class="IDTH">
                <span class="p-column-title">ID</span> #{{exportProcess.identifier}}
              </td>
              <td field="name" class="TEXT">
                <span class="p-column-title">{{'General.name'|translate}}</span>{{exportProcess.name}}
              </td>
              <td field="creationDate" class="DATE">
                <span class="p-column-title">{{'General.date.text.text'|translate}}</span> {{ exportProcess.creationDate
                | date: 'dd/MM/yyyy' }}
              </td>
              <td field="description" class="text-left p-t-md p-b-md LONGTEXT">
                <span class="p-column-title">{{'General.description'|translate}}</span> {{exportProcess.description}}
              </td>
              <td class="text-md-center USER">
                <span class="p-column-title d-inline d-md-none">{{'General.state'|translate}}</span>
                <span class=" d-inline d-md-inline-block"
                  *ngIf="exportProcess.execution&&exportProcess.execution.status&&exportProcess.execution&&exportProcess.execution.status!='running'"
                  [ngClass]="getStatusColor(exportProcess.execution.status)">
                  {{'ExportProcesses.state.'+exportProcess.execution.status|translate}}</span>
                <span class="d-block m-t2"
                  *ngIf="exportProcess.execution&&exportProcess.execution&&exportProcess.execution&&exportProcess.execution.status==='running'">
                  <p-progressBar [value]="exportProcess.execution.progress"></p-progressBar>
                </span>
              </td>
              <td field="ownerUser" class="USER"><span class="p-column-title"> {{'General.user'|translate}}</span>
                <user [user]="exportProcess.ownerUser"></user>
              </td>
              <td class="action-column-4buttons"><span
                  class="p-column-title  d-block d-md-none">{{'General.actions'|translate}}</span>
                <div class="btn-group">
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    (click)="download(exportProcess)"
                    disabled="{{exportProcess.execution&&exportProcess.execution.status&&exportProcess.execution.status==='completed'?'':'disabled'}}">
                    <i class="fas fa-download" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    (click)="viewDetail(exportProcess)">
                    <i class="fas  fa-info-circle" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false" *ngIf="this.canModify"
                    (click)="duplicate(exportProcess)">
                    <i class="fas  fa-copy" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false" *ngIf="this.canModify"
                    (click)="run(exportProcess)"
                    disabled="{{exportProcess.execution&&exportProcess.execution.status&&exportProcess.execution.status==='completed'?'':'disabled'}}">
                    <i class="fas  fa-redo" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">
                <div class="alert alert-info col-12 mt-5" role="alert">
                  <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                    'General.noData' | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="text-center">
              <!-- <td [attr.colspan]="visibleColumns.length + 2" style="padding: 0; margin: 0; border: 0">
                <p-paginator [rows]="pageInfo.size" [first]="pageInfo.number * pageInfo.size" dropdownAppendTo="body"
                  [totalRecords]="pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]"
                  (onPageChange)="reloadDossier($event)">
                </p-paginator>
              </td> -->
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<!-- <ng-template #noExportProcess>
    <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert"><span>
        <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'Logs.noLogs' | translate }}</span>
    </div>
  </ng-template> -->